// Маленькое общее хранилище: значение и подписчики. Компоненты читают его через useStore и обновляются вместе.
import { useSyncExternalStore } from "react";

export class Store<T> {
  private listeners = new Set<() => void>();
  constructor(private value: T) {}
  get = () => this.value;
  set = (value: T) => {
    this.value = value;
    for (const listener of this.listeners) listener();
  };
  update = (change: (value: T) => T) => this.set(change(this.value));
  subscribe = (listener: () => void) => {
    this.listeners.add(listener);
    return () => { this.listeners.delete(listener); };
  };
}

export const useStore = <T,>(store: Store<T>): T => useSyncExternalStore(store.subscribe, store.get);
